/**
 * Fill [potential_points] from the selected variant and selling plan.
 * Rivo's widget stays on the main product price.
 */

const originals = new Map()

const rate = (() => {
  try {
    const parsed = JSON.parse(document.getElementById('rivo-points-rate').textContent)
    return {
      pointsAmount: Number(parsed.pointsAmount) || 0,
      currencyBase: Number(parsed.currencyBase) || 1,
      basePriceCents: Number(parsed.basePriceCents) || 0,
    }
  } catch {
    return { pointsAmount: 0, currencyBase: 1, basePriceCents: 0 }
  }
})()

function selectedPriceCents() {
  const product =
    window.productData || JSON.parse(document.querySelector('[id^="ProductJson-"]')?.textContent || 'null')
  const id =
    new URLSearchParams(location.search).get('variant') ||
    document.querySelector('[data-product-form] [name="id"]')?.value
  const variant = product?.variants?.find((item) => String(item.id) === String(id)) || product?.variants?.[0]
  if (!variant) return 0
  const planId =
    document.querySelector('[name="selling_plan"]')?.value ||
    document.querySelector('[name="product-subscription"]:checked')?.dataset?.sellingPlanId
  return (
    (planId &&
      variant.selling_plan_allocations?.find((item) => String(item.selling_plan_id) === String(planId))?.price) ??
    variant.price
  )
}

function pointsFor(cents) {
  if (!cents || !rate.pointsAmount || !rate.currencyBase) return ''
  return String(Math.round(((cents / 100) * rate.pointsAmount) / rate.currencyBase))
}

function paint(value) {
  if (!value) return
  const amountEl = document.querySelector('.order-placed-potential-points-amount')
  if (amountEl && amountEl.textContent.trim() !== value) amountEl.textContent = value

  let hid = false
  for (const el of document.querySelectorAll('.product__callouts-item-text p')) {
    if (!originals.has(el) && el.textContent.includes('[potential_points]')) originals.set(el, el.textContent)
    const original = originals.get(el)
    if (!original) continue
    el.textContent = original.replaceAll('[potential_points]', value)
    hid = true
  }
  if (hid) {
    const widget = document.querySelector('#loy-potential-points')
    if (widget) widget.style.display = 'none'
  }
}

function update() {
  paint(pointsFor(selectedPriceCents()))
}

function start(attempt = 0) {
  const amountEl = document.querySelector('.order-placed-potential-points-amount')
  if (amountEl?.textContent.trim()) {
    const widgetPoints = Number.parseFloat(amountEl.textContent)
    const expected = ((rate.basePriceCents / 100) * rate.pointsAmount) / rate.currencyBase
    if (widgetPoints > 0 && expected > 0) {
      const factor = widgetPoints / expected
      const nearest = Math.round(factor)
      if (nearest >= 1 && Math.abs(factor - nearest) < 0.05) rate.pointsAmount *= nearest
    }
    update()
    new MutationObserver(update).observe(amountEl, { childList: true, subtree: true, characterData: true })
    return
  }
  if (attempt >= 30) return update()
  setTimeout(() => start(attempt + 1), 200)
}

document.addEventListener('product-form:option-change', update)
document.addEventListener('change', (event) => {
  if (
    event.target.closest?.(
      '[name="product-subscription"], [name="selling_plan"], [data-product-subscription-select] select'
    )
  ) {
    update()
  }
})

start()
